import { render, staticRenderFns } from "./take-order.vue?vue&type=template&id=802a4bbc&scoped=true"
import script from "./take-order.vue?vue&type=script&lang=js"
export * from "./take-order.vue?vue&type=script&lang=js"
import style0 from "./take-order.vue?vue&type=style&index=0&id=802a4bbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802a4bbc",
  null
  
)

export default component.exports